import Link from 'next/link'
import Heading from 'components/heading/heading'
import Meta from 'components/meta/meta'
import Articles from 'components/articles/articles'
import { getData, getList } from 'utils/api'
import { cn, getRoute } from 'utils/helpers'
import styles from 'styles/page/tinklarastis.module.scss'

export default function Page(props) {
    if (!props.categories || !props.categories.length) {
        return ''
    }

    return (
        <>
            <Meta title={props.categories[0].name} description={props.categories[0].description} />
            <section className={cn(styles.intro, 'mb72')}>
                <Link href={getRoute('buyerblog')}>
                    <a className={styles.introLink}>Tinklaraštis pirkėjams</a>
                </Link>
                <Heading tag="h1" size="36">
                    {props.categories[0].name}
                </Heading>
            </section>
            <section>
                <Articles articles={props.articles} />
            </section>
        </>
    )
}

export async function getStaticProps(context) {
    return getData(`articles/buyers?category=${context.params.slug}`)
}

export async function getStaticPaths() {
    return getList('articles-category-list/buyers')
}
